import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ShimmerCardContainer } from './ShimmerCard.styles';
import { ShimmerCardProps } from './ShimmerCard.types';

export const ShimmerCard = ({ width, height }: ShimmerCardProps) => {
  return (
    <ShimmerCardContainer $width={width} $height={height}>
      <Skeleton
        count={5}
        containerClassName="skeleton-span-container"
        baseColor="#ebebeb"
        highlightColor="#f5f5f5"
      />
    </ShimmerCardContainer>
  );
};
